import axios from "../axios"
import {
    IGatewayConfigEditParams,
    IGatewayConfigGetData,
    IGatewayConfigGetParams,
    IGatewayConfigGetStateData,
    IGatewayConfigGetStateParams,
    IGatewayConfigSensorTerminalParams as IGatewayConfigGatewayTerminalParams,
    IGatewayCreateParams,
    IGatewayEditParams,
    IGatewayGetCardParams,
    IGatewayGetChannelAndFreqParams,
    IGatewayGetIPAndPortParams,
    IGatewayGetNetWorkInfoParams,
    IGatewayItem,
    IGatewayListData,
    IGatewayListPageData,
    IGatewayListPageParams,
    IGatewayLoraNetworkBindParams,
    IGatewayLoraNetworkEditParams,
    IGatewayLoraNetworkFindListData,
    IGatewayLoraNetworkFindListParams,
    IGatewayLoraNetworkFindSensorListData,
    IGatewayLoraNetworkFindSensorListParams,
    IGatewayLoraNetworkStopLoraNetworkingParams,
    IGatewayLoraNetworkUnbindParams,
    IGatewayQueryNetWorkInfoData,
    IGatewayQueryNetWorkInfoParams,
    IGatewaySelectListData
} from "./gateway.types"

/**
 * 网关分页列表 
 */
export function gatewayListPage(params: IGatewayListPageParams) {
    return axios<IGatewayListPageData>({
        url: '/gateway/findPage',
        method: 'post',
        data: params,
    })
}

/**
 * 网关删除
 */
export function gatewayDelete(params: { id: number }) {
    return axios({
        url: '/gateway/del',
        method: 'get',
        params,
    })
}

/**
 * 新增网关
 */
export function gatewayCreate(params: IGatewayCreateParams) {
    return axios({
        url: '/gateway/save',
        method: 'post',
        data: params,
    })
}

/**
 * 编辑网关 
 */
export function gatewayEdit(params: IGatewayEditParams) {
    return axios({
        url: '/gateway/edit',
        method: 'post',
        data: params,
    })
}

/**
 * 获取单个网关
 */
export function gatewayInfo(params: { id: number }) {
    return axios<IGatewayItem>({
        url: '/gateway/get',
        method: 'get',
        params,
    })
}

/**
 * 获取选项 
 */
export function gatewaySelectList() {
    return axios<IGatewaySelectListData>({
        method: 'get',
        url: '/gateway/select/list'
    })
}

/**
 * 获取网关下拉选
 */
export function gatewayList(params?: { companyId: number }) {
    return axios<IGatewayListData>({
        method: 'get',
        url: '/gateway/list',
        params: params,
    })
}

/**
 * 下发配置 
 */
export function gatewayPushSetting(devId: number) {
    return axios({
        method: 'post',
        url: `/gateway/pushSetting/${devId}`
    })
}

/**
 * 重启
 */
export function gatewayRestart(devId: number) {
    return axios({
        method: 'post',
        url: `/gateway/restart/${devId}`
    })
}

/**
 *  读取无线通道频段
 */
export function gatewayGetChannelAndFreq(params: IGatewayGetChannelAndFreqParams) {
    return axios({
        method: 'get',
        url: '/gateway/getChannelAndFreq',
        params
    })
}

/**
 *  读取网关网卡信息
 */
export function gatewayGetCard(params: IGatewayGetCardParams) {
    return axios({
        method: 'get',
        url: '/gateway/getGatewayCard',
        params
    })
}

/**
 *  读取服务器IP和端口
 */
export function gatewayGetIPAndPort(params: IGatewayGetIPAndPortParams) {
    return axios({
        method: 'get',
        url: '/gateway/getServerIpAndPort',
        params
    })
}

/**
 * VB24H网关-读取WIFI/4G信息
 */
export function gatewayGetNetWorkInfo(params: IGatewayGetNetWorkInfoParams) {
    return axios({
        method: 'get',
        url: '/gateway/gatewayNetworkInfo',
        params
    })
}


/**
 * VB24H网关-查询WIFI/4G信息
 */
export function gatewayQueryNetWorkInfo(params: IGatewayQueryNetWorkInfoParams) {
    return axios<IGatewayQueryNetWorkInfoData>({
        method: 'get',
        url: '/gateway/queryGatewayNetworkInfo',
        params
    })
}


// Lora组网API

/**
 *  网关绑定传感器
 */
export function gatewayLoraNetworkBind(params: IGatewayLoraNetworkBindParams) {
    return axios({
        method: 'post',
        url: '/gateway/LoraNetworking/bind',
        data: params
    })
}

/**
 *  编辑网关
 */
export function gatewayLoraNetworkEdit(params: IGatewayLoraNetworkEditParams) {
    return axios({
        method: 'post',
        url: '/gateway/LoraNetworking/edit',
        data: params
    })
}

/**
 *  查询网关列表
 */
export function gatewayLoraNetworkFindList(params: IGatewayLoraNetworkFindListParams) {
    return axios<IGatewayLoraNetworkFindListData>({
        method: 'post',
        url: '/gateway/LoraNetworking/findList',
        data: params
    })
}

/**
 *  查询传感器列表
 */
export function gatewayLoraNetworkFindSensorList(params: IGatewayLoraNetworkFindSensorListParams) {
    return axios<IGatewayLoraNetworkFindSensorListData>({
        method: 'post',
        url: '/gateway/LoraNetworking/findSensorList',
        data: params
    })
}

/**
 *  终止组网
 */
export function gatewayLoraNetworkStopLoraNetworking(params: IGatewayLoraNetworkStopLoraNetworkingParams) {
    return axios({
        method: 'post',
        url: '/gateway/LoraNetworking/stopLoraNetworking',
        data: params
    })
}

/**
 *  解绑传感器
 */
export function gatewayLoraNetworkUnbind(params: IGatewayLoraNetworkUnbindParams) {
    return axios({
        method: 'post',
        url: '/gateway/LoraNetworking/unbind',
        data: params
    })
}


// 通用网关配置API

/**
 *  修改网关配置
 */
export function gatewayConfigEdit(params: IGatewayConfigEditParams) {
    return axios({
        method: 'post',
        url: '/gateway/config/editGateway',
        data: params
    })
}

/**
 *  获取网关配置
 */
export function gatewayConfigGet(params: IGatewayConfigGetParams) {
    return axios<IGatewayConfigGetData>({
        method: 'get',
        url: '/gateway/config/getGateway',
        params
    })
}

/**
 *  获取网关状态
 */
export function gatewayConfigGetState(params: IGatewayConfigGetStateParams) {
    return axios<IGatewayConfigGetStateData>({
        method: 'get',
        url: '/gateway/config/getGatewayState',
        params
    })
}

/**
 *  网关-终端
 */
export function gatewayConfigGatewayTerminal(params: IGatewayConfigGatewayTerminalParams) {
    return axios({
        method: 'get',
        url: '/gateway/config/gatewayTerminal',
        params
    })
}

/**
 *  网关-恢复出厂设置
 */
export function gatewayConfigGatewayFactoryReset(params: IGatewayConfigGetParams) {
    return axios({
        method: 'get',
        url: '/gateway/config/gatewayFactoryReset',
        params
    })
}
